import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { ActionTypes, NotificationsActions } from '../actions/notifications';

export interface NotificationsState {
  notifications: Array<any>;
  unit: number;
  unread: number;
  unseen: number;
  selectedApplicationUnread: number;
}

export const initialState: NotificationsState = {
  notifications: [],
  unit: null,
  unread: null,
  unseen: null,
  selectedApplicationUnread: 0,
};

export const adapter: EntityAdapter<NotificationsState> = createEntityAdapter<
  NotificationsState
>();

export function NotificationsReducer(
  state = initialState,
  action: NotificationsActions
) {
  switch (action.type) {
    case ActionTypes.UpdateNotifications:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
